module.exports = __webpack_public_path__ + "static/media/handbags_getty_desktop.feb95e52.jpg";